document.addEventListener('DOMContentLoaded', function () {
  var hiddenAnchors = window.__hiddenAnchors || [];
  if (hiddenAnchors.length) {
    hiddenAnchors.forEach(function (anchorId) {
      var items = document.querySelectorAll('.button-list__item[data-anchor-id="' + anchorId + '"]');
      items.forEach(function (item) {
        item.style.display = 'none';
      });
    });
  }

  var stickySections = document.querySelectorAll('.section.button-list.-sticky');

  stickySections.forEach(function (sectionEl) {
    var anchorButtons = sectionEl.querySelectorAll('.-anchor-button');
    if (!anchorButtons.length) return;

    var anchors = [];

    anchorButtons.forEach(function (btn) {
      var href = btn.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      var id = href.substring(1);
      var anchorEl = document.getElementById(id);
      if (!anchorEl) return;

      anchors.push({
        id: id,
        element: anchorEl,
        button: btn
      });
    });

    if (!anchors.length) return;

    anchorButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href');
        if (!href || !href.startsWith('#')) return;

        e.preventDefault();

        var id = href.substring(1);
        var anchorObj = anchors.find(function (a) {
          return a.id === id;
        });
        if (!anchorObj) return;

        anchorObj.element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });

    function clearActive() {
      anchorButtons.forEach(function (b) {
        b.classList.remove('-active');
      });
    }

    function getAnchorPageTop(el) {
      return el.getBoundingClientRect().top + window.scrollY;
    }

    function updateActive() {
      var scrollY = window.scrollY;
      var activationOffset = 50;

      anchors.sort(function (a, b) {
        return getAnchorPageTop(a.element) - getAnchorPageTop(b.element);
      });

      var current = null;

      anchors.forEach(function (a) {
        var realTop = getAnchorPageTop(a.element);
        if (scrollY + activationOffset >= realTop) {
          current = a;
        }
      });

      if (!current) {
        clearActive();
        return;
      }

      clearActive();
      current.button.classList.add('-active');
    }

    window.addEventListener('scroll', updateActive);
    window.addEventListener('resize', updateActive);

    updateActive();
  });
});
